/*** Segment/Amplitude Events */

export enum Events {
  AccountCreated = 'Account Created',
  ButtonClicked = 'Button Clicked',
  CheckoutCancelledCancelClicked = 'Checkout Cancelled Cancel Clicked',
  CheckoutCancelledContinueClicked = 'Checkout Cancelled Continue Clicked',
  CheckoutSuccessExploreDashboardClicked = 'Checkout Success Explore Dashboard Clicked',
  CheckoutSuccessExploreRoutineClicked = 'Checkout Success Explore Routine Clicked',
  CheckoutSuccessTrackOrderStatusClicked = 'Checkout Success Track Order Status Clicked',
  ClickedPSITransitionCircle = 'Clicked PSI Transition Circle',
  ContactUsClicked = 'Clicked button for contact us',
  LabBiomarkerResultClicked = 'Biomarker Arrow Clicked',
  LabKitActivationCompleted = 'Activation Completed',
  LabKitActivationPageShown = 'Activation Page Shown',
  LabKitPurchased = 'Test Kit Purchased',
  LabRelatedReferenceClicked = 'Related Reference Clicked',
  LabRelatedResultsClicked = 'Related Results Clicked',
  LabResultsRangeToggleClicked = 'Results Range Toggle Clicked',
  LabsModuleButtonClicked = 'Labs Module Button Clicked',
  LinkClicked = 'Hyperlink Clicked',
  loggedIn = 'Logged In',
  ManageSubscriptionClicked = 'Clicked button for manage account',
  ModalShown = 'Modal Shown',
  PageTabClicked = 'Page Tab Clicked',
  PhoneConfirmationSuccessExploreDashboardClicked = 'Phone Confirmation Success Explore Dashboard Clicked',
  PhoneNumberVerified = 'Phone Number Verified',
  QuizFinished = 'Quiz Questions Finished',
  QuizStarted = 'Quiz Questions Started',
  RoutineCreated = 'Routine Created',
  SentToCheckoutStripe = 'Checkout Initiated',
  ViewOrderDetailsClicked = 'Clicked button for order details',
  ViewReceiptClicked = 'Clicked button for view receipt',
  ZendeskWigetClick = 'Widget Clicked'
}

/*** Events Properties */
export interface EventProperties {
  [Events.AccountCreated]: undefined;
  [Events.ButtonClicked]: {
    button_label: string;
    url: string;
    user_email: string;
  };
  [Events.LinkClicked]: {
    text: string;
  };
  [Events.CheckoutCancelledCancelClicked]: undefined;
  [Events.CheckoutCancelledContinueClicked]: undefined;
  [Events.CheckoutSuccessTrackOrderStatusClicked]: undefined;
  [Events.CheckoutSuccessExploreDashboardClicked]: undefined;
  [Events.CheckoutSuccessExploreRoutineClicked]: undefined;
  [Events.ClickedPSITransitionCircle]: undefined;
  [Events.loggedIn]: undefined;
  [Events.ModalShown]: {
    flow: string;
    modal_type: string;
  };
  [Events.PhoneConfirmationSuccessExploreDashboardClicked]: undefined;
  [Events.PhoneNumberVerified]: undefined;
  [Events.QuizFinished]: { quiz_type: string };
  [Events.QuizStarted]: { quiz_type: string };
  [Events.RoutineCreated]: {
    challenge_name: string;
    check_in_time: string;
    check_in_timezone: string;
    cue: string;
  };
  [Events.ZendeskWigetClick]: {
    sage_person_id: string;
    url: string;
    widget_type: string;
  };
  [Events.ContactUsClicked]: {
    button: string;
    sage_person_id?: string;
    url: string;
  };
  [Events.SentToCheckoutStripe]: {
    url: string;
  };
  [Events.ManageSubscriptionClicked]: undefined;
  [Events.ViewReceiptClicked]: undefined;
  [Events.ViewOrderDetailsClicked]: undefined;

  // Labs
  [Events.LabBiomarkerResultClicked]: {
    biomarker: string; // display (full) name
    result_conclusion: string; // 'Out of range', 'In range', 'No result'
  };
  [Events.LabsModuleButtonClicked]: {
    button_label: string;
    order_status: string;
  };
  [Events.LabKitActivationPageShown]: {
    page_name: string;
  };
  [Events.LabKitPurchased]: {
    product_id: string; // the Stripe product id
  };
  [Events.LabKitActivationCompleted]: undefined;
  [Events.LabResultsRangeToggleClicked]: {
    range_type: string;
  };
  [Events.PageTabClicked]: {
    tab_name: string;
  };
  [Events.LabRelatedReferenceClicked]: {
    biomarker?: string; // name of current marker
    reference_title?: string; // name of article
  };
  [Events.LabRelatedResultsClicked]: {
    biomarker?: string; // name of current marker
    related_result?: string; // name of biomarker user is navigation to
  };
}
